import { environment } from "./environment.js";
import { features } from "./features.js";
import { htmlMeta } from "./html-meta.js";
const production = {
    environment,
    htmlMeta,
    features
};
export { production };
